//Cookie functions
function setTheCookie(name,value,days) {
  var expires = "";
  if (days) {
      var date = new Date();
      date.setTime(date.getTime() + (days*24*60*60*1000));
      expires = "; expires=" + date.toUTCString();
  }
  document.cookie = name + "=" + (value || "")  + expires + "; path=/";
}
    
function getTheCookie(name) {
  var nameEQ = name + "=";
  var ca = document.cookie.split(';');
  for(var i=0;i < ca.length;i++) {
      var c = ca[i];
      while (c.charAt(0)==' ') c = c.substring(1,c.length);
      if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length,c.length);
  }
  return null;
}

$(document).ready(function () {
  //Quiz result

  var globalQuizOptions = []; // Define global variables to store the values
  
  //store quiz index array values in cookie
  function setQuizOptionsCookie() {
    var quizOptionsJson = JSON.stringify(globalQuizOptions)
    setTheCookie("quizResult", quizOptionsJson, 7);
  }

  //get the quiz result from the cookie
   function getQuizresultCookie(){
    var quizOptionsCookie = getTheCookie("quizResult");
   }
  
   $(document).on('click', '.oct-quiz-multiple-choice-options__option', function() {
      var quizOptionIndex = $(this).find('div').first().text().trim();
     console.log(quizOptionIndex);
      var quizOptionTitle = $(this).parents().parents('[data-element="oct-quiz-multiplechoice oct-quiz-media"]').parents().find('[data-element="oct-quiz-text oct-quiz-title"]').text();
     
      // Store the values globally
      globalQuizOptions.push({ quizOptionTitle, quizOptionIndex });
      setQuizOptionsCookie();
   });
  // $(document).on('click', '[data-element="oct-quiz-input oct-quiz-media"] button', function() {
  //     var quizOptionIndex = $(this).find('input').val().trim();
  //     var quizOptionTitle = $(this).closest('[data-element="oct-quiz-text oct-quiz-title"]').text().trim();
      
  //     // Store the values globally
  //     globalQuizOptions.push({ quizOptionTitle, quizOptionIndex });
  //     setQuizOptionsCookie();
  //     console.log(quizOptionIndex);
  //   });
  //   $(document).on('click', function(event) {
  //     var clickedElement = $(event.target);
      
  //     // Check if the clicked element has the specified classes
  //     if (clickedElement.hasClass('oct-quiz-multiple-choice-options__option')) {
  //         // Retrieve quizOptionIndex and quizOptionTitle
  //         var quizOptionIndex = clickedElement.find('div').first().text().trim();
  //         var quizOptionTitle = clickedElement.parents().parents('[data-element="oct-quiz-multiplechoice oct-quiz-media"]').parents().find('[data-element="oct-quiz-text oct-quiz-title"]').text();
          
  //         // Store the values globally
  //         globalQuizOptions.push({ quizOptionTitle, quizOptionIndex });
  //         setQuizOptionsCookie();
  //     } else if (clickedElement.hasClass('oct-quiz-input')) {
  //         // Retrieve input value and quizOptionTitle
  //         var inputText = clickedElement.find('input').val();
  //         var quizOptionTitle = clickedElement.parents('[data-element="oct-quiz-text oct-quiz-title"]').text().trim();
          
  //         // Store the values globally
  //         globalQuizOptions.push({ quizOptionTitle, inputText });
  //         setQuizOptionsCookie();
  //     }
  // });


  if (~window.location.href.indexOf("pages/quiz")) {
    var interval = setInterval(function() {
        if ($('[data-element="oct-quiz-productblock oct-quiz-media"]').length) {
            var quizOptionsCookie = getTheCookie("quizResult");
            var quizOptions = JSON.parse(quizOptionsCookie); // Parse the JSON string from the cookie
            var quizResultContent = `<div class="quiz-options-result-section">
                        <div class="quiz-options-result-container">
                            <ul class="quiz-option-result-list"></ul>
                        </div>
                    </div>`;
            $('<div class="quiz-result-container">' + quizResultContent + '</div>').insertAfter('[data-element="oct-quiz-text oct-quiz-title"]');
            var $quizOptionList = $('.quiz-option-result-list');
            quizOptions.forEach(function(option) {
                $quizOptionList.append(`<li>
                    <span class="quiz-selected-question">${option.quizOptionTitle} -</span>
                    <span class="quiz-selected-answer">${option.quizOptionIndex}</span>
                </li>`);
            });
            clearInterval(interval);
        }
    }, 100);
  }
  $(document).on('change','.product-form__input--dropdown .select .select__select', function () {
   let otherOption = $(this).parents('.product-form__input').next('.product-meta-selector').find('.single-option-selector__wrap-option');
    
    otherOption.each(function() {
        let inputValue = $(this).find('input').val();
        // console.log("inputValue::" + inputValue);
    });
    let week4 = '4 Week';
    let week12 = '12 Week';
    var mainInpval = $('#main_vari_input').val();
    //console.log('mainInpval::'+mainInpval);
    let select_varaint_title = $('.cdkMasterSelect_sub option[value='+mainInpval+']').attr('data-subscription');
    var subPrice = $('.cdkMasterSelect_sub option[value='+mainInpval+']').attr('data-subscription');
    var mainPrice = $('.cdkMasterSelect_sub option[value='+mainInpval+']').attr('data-subsciption-actual');
    var variant_title_first = $('.cdkMasterSelect_sub option[value='+mainInpval+']').attr('data-subscription-title').split("/")[0].trim();
    // var variant_title_last = $('.cdkMasterSelect_sub option[value='+mainInpval+']').attr('data-subscription-title').split("/")[1].trim();
    // console.log('subPrice::'+subPrice);
    // console.log('mainPrice::'+mainPrice);
    // console.log('variant_title_first::'+variant_title_first);

    let week4sellingPrice = $('.cdkMasterSelect_sub option[data-subscription-title="' + variant_title_first + '"][data-subscription-value="' + week4 + '"]').attr('data-subscription');
    let week4sellingComprice = $('.cdkMasterSelect_sub option[data-subscription-title="' + variant_title_first + '"][data-subscription-value="' + week4 + '"]').attr('data-subsciption-actual');

    let week12sellingPrice = $('.cdkMasterSelect_sub option[data-subscription-title="' + variant_title_first + '"][data-subscription-value="' + week12 + '"]').attr('data-subscription');
    let week12sellingComprice = $('.cdkMasterSelect_sub option[data-subscription-title="' + variant_title_first + '"][data-subscription-value="' + week12 + '"]').attr('data-subsciption-actual');
    // console.log('week4price::'+week4price);
    var selling_percentage = $('.cdkMasterSelect_sub option[value='+mainInpval+']').attr('data-discount');
      $('.cdk_selling_price_main').text(subPrice);
      $('.selling_percentage').text(selling_percentage);
    $('.single-option-selector__wrap-option input[value="' + week4 + '"] + .single-option-selector__option-wrap .selling-price').text(week4sellingPrice);
    $('.single-option-selector__wrap-option input[value="' + week4 + '"] + .single-option-selector__option-wrap .one-time-price').text(week4sellingComprice);

    $('.single-option-selector__wrap-option input[value="' + week12 + '"] + .single-option-selector__option-wrap .selling-price').text(week12sellingPrice);
    $('.single-option-selector__wrap-option input[value="' + week12 + '"] + .single-option-selector__option-wrap .one-time-price').text(week12sellingComprice);
    
  })

  $(document).on('click', '.variants-content.product__dropdown-select .product-form__input .single-option-selector__wrap-option input[type="radio"]', function() {
    // console.log("click");
    let varaintTitle = $(this).attr('value');
    // console.log("title::"+ varaintTitle);
    
    // Use correct concatenation and syntax
    let fixed_subPrice = $('.cdkMasterSelect_sub option[data-subscription-title="' + varaintTitle + '"]').attr('data-subscription');
    let fixed_mainPrice = $('.cdkMasterSelect_sub option[data-subscription-title="' + varaintTitle + '"]').attr('data-subsciption-actual');
    let fixed_selling_percentage = $('.cdkMasterSelect_sub option[data-subscription-title="' + varaintTitle + '"]').attr('data-discount');
    let subscribed = $(this).parents('.product__meta-grid').find('.cdk--custom_subscription_options .subscription_pan_item.active').attr('data-type');
    // let deliveryText = $(this).parents('.product__meta-grid').find('.rc-selling-plans-single').text();

    // console.log('subPrice::'+fixed_subPrice);
    // console.log('mainPrice::'+fixed_mainPrice);
    // console.log('discount::'+fixed_selling_percentage);
    $('.fixed-percent-off .price-off, .fixed_delivery_text .percent__off').text(fixed_selling_percentage);
    $('.fixed--price-wrap .one-time-price').text(fixed_mainPrice);
    $('.fixed--price-wrap .selling-price').text(fixed_subPrice);
    if(subscribed === 'subscription-radio'){
    let self = $(this);
    setTimeout(function() {
        let deliveryText = self.parents('.product__meta-grid').find('.rc-selling-plans-single').text();
        // console.log('deliveryText::'+deliveryText);
        $('.fixed_delivery_text').text(deliveryText);
      }, 500);
    }
    if(subscribed === 'onetime-radio'){
      $('.fixed_delivery_text').text(varaintTitle);
    }
  });

  setTimeout(function() {
    let parentDiv = $('.product-page__content.product-single__page-wrap .product__info-wrapper .product-form__controls-group .product-meta-selector .product-form__input');
    let children = parentDiv.children();
    let newVar = $('.product-page__content.product-single__page-wrap .new_variant_selector.new_subscription_item .new_variant_selector_box');
    let newVarChildren = newVar.children();
    if (children.length === 2 || children.length === 3) {
        $(children[0]).find('input[type=radio]').click();
    }
    if (newVarChildren.length === 2 || newVarChildren.length === 3) {
        $(newVarChildren[0]).find('.new_variant_selector_box-option-wrap').click();
    }
  }, 1000);

  $(document).on('click', '.subscription_pan_item', function() {
    let subType = $(this).attr('data-type');
    $(this).siblings().removeClass('active');
    $(this).addClass('active');
    $('.rc-widget .rc-radio.' + subType).click();
    let $this = $(this);
    setTimeout(function() {
      let percentageOFF = $this.parents('.product__meta-grid').find('.variants-content.product__dropdown-select .single-option-selector--box-your-supply .single-option-selector__wrap-option input[type="radio"]:checked').attr('data-discount');
      // console.log("percentageOFF::"+ percentageOFF);
      if (percentageOFF) {
        $('.new_var_percentage').text(percentageOFF);
      } else {
          $('.new_var_percentage').text('');
      }
    }, 500);
    if (subType == 'subscription-radio'){
      $('.product-form__controls-group').removeClass('one-time--active');
      $('.product-form__controls-group').addClass('subscription--active');

      let varTitle = $(this).parents('.product__meta-grid').find('.variants-content.product__dropdown-select .single-option-selector--box-your-supply .single-option-selector__wrap-option input[type="radio"]:checked').attr('value');
      // console.log("title::"+ varTitle);
      let fixed_subPrice = $('.cdkMasterSelect_sub option[data-subscription-title="' + varTitle + '"]').attr('data-subscription');
      let fixed_mainPrice = $('.cdkMasterSelect_sub option[data-subscription-title="' + varTitle + '"]').attr('data-subsciption-actual');
      let fixed_selling_percentage = $('.cdkMasterSelect_sub option[data-subscription-title="' + varTitle + '"]').attr('data-discount');
      $('.fixed-percent-off .price-off').show();
      $('.fixed-percent-off .price-off').text(fixed_selling_percentage);
      let self = $(this);
      setTimeout(function() {
          let deliveryText = self.parents('.product__meta-grid').find('.rc-selling-plans-single').text();
          // console.log('deliveryText::'+deliveryText);
          $('.fixed_delivery_text').text(deliveryText);
        }, 500);
      $('.fixed--price-wrap .one-time-price').text(fixed_mainPrice);
      $('.fixed--price-wrap .selling-price').text(fixed_subPrice);
      $('.fixed--price-wrap .one-time-price').removeClass('no-strike');
      $('.fixed--price-wrap .selling-price').show();
    }
    else if (subType == 'onetime-radio'){
      $('.product-form__controls-group').addClass('one-time--active');
      $('.product-form__controls-group').removeClass('subscription--active');
      
      let varTitle = $(this).parents('.product__meta-grid').find('.variants-content.product__dropdown-select .single-option-selector--box-your-supply .single-option-selector__wrap-option input[type="radio"]:checked').attr('value');
      // console.log("title::"+ varTitle);
      let fixed_subPrice = $('.cdkMasterSelect_sub option[data-subscription-title="' + varTitle + '"]').attr('data-subscription');
      let fixed_mainPrice = $('.cdkMasterSelect_sub option[data-subscription-title="' + varTitle + '"]').attr('data-subsciption-actual');
      $('.fixed-percent-off .price-off, .fixed_delivery_text .percent__off').hide();
      $('.fixed_delivery_text').text(varTitle);
      $('.fixed--price-wrap .one-time-price').text(fixed_mainPrice);
      $('.fixed--price-wrap .one-time-price').addClass('no-strike');
      $('.fixed--price-wrap .selling-price').hide();
    }
});
  $(document).on("click", ".new_variant_selector_box-option-wrap", function () {
    let varTitle = $(this).parents('.new_variant_selector_box-option').find('input[type="radio"]').attr('value');
    // console.log("title::"+ varTitle);
    $('.new_variant_selector_box-option').removeClass('active');
    $(this).parents('.new_variant_selector_box-option').addClass('active');
    $('.new_variant_selector').removeClass('active');
    $(this).parents('.new_variant_selector').addClass('active');
    
  });
  $(document).on("click", ".new_variant_selector.new_subscription_item .new_variant_selector_box-option-wrap", function () {
    let $clickedElement = $(this);
    let varTitle = $clickedElement.parents('.new_variant_selector_box-option').find('input[type="radio"]').attr('value');
    let variantName = $clickedElement.parents('.new_variant_selector_box-option').attr('variant___name');
    $clickedElement.parents('.product__meta-grid').find('.subscription_pan_item[data-type="subscription-radio"]').trigger('click');
    let subType = $clickedElement.parents('.product__meta-grid').find('.subscription_pan_item.active').attr('data-type');
    // console.log("title::"+ varTitle);
    // console.log("subType::"+ subType);
    $('.new_subscritpion_benifits_list').hide();
    $clickedElement.parents('.new_variant_selector').find('.new_subscritpion_benifits_list[variant___name="' + variantName + '"]').show();
    if (subType == 'subscription-radio'){
      setTimeout(function() {
        $clickedElement.parents('.product__meta-grid').find('.product-form__controls-group.subscription--active variant-selects .product-form__input input[value="' + varTitle + '"]').trigger('click');
      }, 100);
    }
  });
  $(document).on("click", ".new_variant_selector.new_onetime_item .new_variant_selector_box-option-wrap", function () {
    let $clickedElement = $(this);
    let varTitle = $clickedElement.parents('.new_variant_selector_box-option').find('input[type="radio"]').attr('value');
    $clickedElement.parents('.product__meta-grid').find('.subscription_pan_item[data-type="onetime-radio"]').trigger('click');
    let subType = $clickedElement.parents('.product__meta-grid').find('.subscription_pan_item.active').attr('data-type');
    console.log("subType::"+ subType);
    if (subType == 'onetime-radio'){
      setTimeout(function() {
        $clickedElement.parents('.product__meta-grid').find('.product-form__controls-group.one-time--active variant-selects .product-form__input input[value="' + varTitle + '"]').trigger('click');
      }, 100);
    }
  });
 
  $(document).on("click", ".cover_image .video-play", function () {
    $(this).parents(".cover-img-video").find("video").trigger("play");
    $(this).parents(".cover-img-video").find(".cover_image").hide();
    $(this).parents(".video").siblings().find(".cover-img-video video").trigger("pause");
    $(this).parents(".video").siblings().find(".cover-img-video .cover_image").show();
  });
  $(".video .video-sound").click(function (e) {
    var VideoSoundD = $(this).parents(".cover-img-video").find("video");
    if (VideoSoundD.prop("muted", true)) {
      VideoSoundD.prop("muted", false);
    } else VideoSoundD.prop("muted", false);
    {
      VideoSoundD.prop("muted", true);
    }
 });

  $('.video-list-wrapper').slick({
  dots: false,
  arrows: false,
  infinite: false,
  speed: 300,
  slidesToShow: 4,
  slidesToScroll: 1,
  prevArrow:"<svg class='prev-arrow' width='100%' height='100%' viewBox='0 0 32 32' fill='none' xmlns='http://www.w3.org/2000/svg'><circle cx='16' cy='16' r='16' fill='' fill-opacity='1'></circle><path d='M18.5 8.5L11 16L18.5 23.5' stroke='#1e988a' stroke-width='2' stroke-linecap='square'></path></svg>",
  nextArrow:"<svg class='next-arrow' width='100%' height='100%' viewBox='0 0 32 32' fill='none' xmlns='http://www.w3.org/2000/svg'><circle cx='16' cy='16' r='16' fill='' fill-opacity='1'></circle><path d='M13.5 8.5L21 16L13.5 23.5' stroke='#1e988a' stroke-width='2' stroke-linecap='square'></path></svg>",
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 1
      }
    },
    {
      breakpoint: 767,
      settings: {
        slidesToShow: 2.1,
        slidesToScroll: 1
      }
    }
  ]
 });
  $(document).on("click", ".video_list_wrapper .video-play", function () {
    $(this).hide();
    $(this).parents(".video_list_wrapper").find("video").trigger("play");
    $(this).parents(".video_list_wrapper").find(".video-overlay").addClass('active');
    $(this).parents(".video_list_wrapper").siblings('.video_list_wrapper').find("video").trigger("pause");
    $(this).parents(".video_list_wrapper").siblings('.video_list_wrapper').find(".video-play").show();
    // $(this).parents(".video").siblings().find(".video_list_wrapper .cover_image").show();
  });
  $(document).on("click", ".video_list_wrapper .video-overlay", function () {
    $(this).removeClass('active');
    $(this).parents(".video_list_wrapper").find("video").trigger("pause");
    $(this).parents(".video_list_wrapper").find(".video-play").show();
  });
  $(document).on("click", ".icon-play-wrapper", function () {
   var videoElement = $(this).closest(".section-single-video").find("video")[0]; // Get the video element
    if (videoElement) {
        if (videoElement.paused) {
            videoElement.play();
            $(this).hide();
            videoElement.setAttribute("controls", "true");
        } else {
             videoElement.pause(); // Pause the video
            $(this).show(); // Show the play icon (SVG) again
        }
    }
  });
  

 //  $(".video_list_wrapper .video-sound").click(function (e) {
 //    var VideoSoundD = $(this).parents(".video_list_wrapper").find("video");
 //    if (VideoSoundD.prop("muted", true)) {
 //      VideoSoundD.prop("muted", false);
 //    } else VideoSoundD.prop("muted", false);
 //    {
 //      VideoSoundD.prop("muted", true);
 //    }
 // });
  $(".video_list_wrapper .video-sound").click(function (e) {
    var VideoSoundD = $(this).parents(".video_list_wrapper").find("video");
    
    // Toggle mute state
    if (VideoSoundD.prop("muted")) {
        VideoSoundD.prop("muted", false);  // Unmute the video
    } else {
        VideoSoundD.prop("muted", true);   // Mute the video
    }
});
$('.video-review').slick({
  dots: false,
  arrows: true,
  infinite: true,
  autoplay: true,
  autoplaySpeed: 3000,
  slidesToShow: 4,
  slidesToScroll: 1,
  prevArrow:"<svg class='prev-arrow' width='100%' height='100%' viewBox='0 0 32 32' fill='none' xmlns='http://www.w3.org/2000/svg'><circle cx='16' cy='16' r='16' fill='' fill-opacity='1'></circle><path d='M18.5 8.5L11 16L18.5 23.5' stroke='#1e988a' stroke-width='2' stroke-linecap='square'></path></svg>",
  nextArrow:"<svg class='next-arrow' width='100%' height='100%' viewBox='0 0 32 32' fill='none' xmlns='http://www.w3.org/2000/svg'><circle cx='16' cy='16' r='16' fill='' fill-opacity='1'></circle><path d='M13.5 8.5L21 16L13.5 23.5' stroke='#1e988a' stroke-width='2' stroke-linecap='square'></path></svg>",
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 4,
        slidesToScroll: 1
      }
    },
    {
      breakpoint: 767,
      settings: {
        arrows: false,
        slidesToShow: 2.1,
        slidesToScroll: 1
      }
    }
  ]
 });
 
  
 $(document).on("click", ".sidebar_opener", function () {
   $(this).addClass('active')
   $('.sidebar_wrap').addClass('active');
   $('html,body').addClass('overflow-hidden-tablet');
 });
 $(document).on("click", ".sidewar__close,.sidebar_overlay", function () {
   $(this).removeClass('active')
   $('.sidebar_wrap').removeClass('active');
   $('html,body').removeClass('overflow-hidden-tablet'); 
 });

 $(window).on('scroll', function() {
   const footerGroup = $('.shopify-section-group-footer-group');
   const windowBottom = $(window).scrollTop() + $(window).height();
   const footerTop = footerGroup.offset().top;
   const button = $('.sidebar_opener');
   if (button.length) {
     if (windowBottom + 1 >= footerTop) {
       $('.sidebar_btn_wrapper').addClass('hide');
     } else {
       $('.sidebar_btn_wrapper').removeClass('hide');
     }
   }
 });
 
 
 
 $(document).on('click', '.open_popup', function() {
   $('.cart__popup').addClass('active');
   $(this).parents('.cart-drawer').find('cart-drawer-items .cart-drawer-recommendations').addClass('close');
 });
 $(document).on('click', '.cart__popup .popup__close', function() {
   $('.cart__popup').removeClass('active');
   $(this).parents('.cart-drawer').find('cart-drawer-items .cart-drawer-recommendations').removeClass('close');
 });

 // 

 
 $(document).on('click', '.cdk_option_selector .single-option-selector__wrap-option .single-option-selector__option', function() {
   let variantId = $(this).attr('variant__id');
   let sellingId = $(this).attr('selling___id');
   $(this).parents('.cdk_option_selector').find('.single-option-selector__wrap-option').removeClass('active');
   $(this).parents('.single-option-selector__wrap-option').addClass('active');
   let addForm = $(this).parents('.cdk__selector').find('.shopify-product-form');
   let variantInput = addForm.find('input[name="id"]');
   let sellingPlanInput = addForm.find('input[name="selling_plan"]');
   if (variantInput.length > 0) {
       variantInput.val(variantId);
   }
  //  if (sellingPlanInput.length > 0) {
  //      sellingPlanInput.val(sellingId);
  //  } else {
  //      addForm.append('<input type="hidden" name="selling_plan" value="' + sellingId + '">');
  //  }
 });

 $(document).on('click', '.cdk__selector_bt', function() {
   $(this).addClass('hidden');
   $(this).parents('.cart__row').find('.cdk__selector').show();
   $(this).parents('.cart__row').find('.cdk_option_selector .single-option-selector__wrap-option.single-option-selector__wrap-option-2 .single-option-selector__option').trigger('click');
   // Scroll the parent .cart__row to the top of the .empty_cart_products container
   $('.empty_cart_products').animate({
       scrollTop: $(this).closest('.cart__row').offset().top - $('.empty_cart_products').offset().top + $('.empty_cart_products').scrollTop() - 8
   }, 300); // 300ms scroll speed
 });

 $(document).on('click', '.cdk_swatch_close', function() {
   $(this).parents('.cart__row').find('.cdk__selector_bt').removeClass('hidden');
   $(this).parents('.cart__row').find('.cdk__selector').hide();
 });

 $(document).on('click', '.cdk__selector .cdk_add_overlay', function() {
   var $this = $(this);
   
   $.ajax({
       type: 'POST',
       url: '/cart/clear.js',
       dataType: 'json',
       success: function(response) {
           $this.next('button').trigger('click');
       },
       error: function(error) {
           console.error('Error clearing cart:', error);
       }
   });
 });

 setTimeout(function() {
   let featparentDiv = $('.featured-product-landing .product__info-wrapper .product-form__controls-group .product-meta-selector .product-form__input');
   if (featparentDiv.length > 0){
     let featchildren = featparentDiv.children();
     if (featchildren.length === 2 || featchildren.length === 3) {
         $(featchildren[1]).find('input[type=radio]').click();
     }
   }
 }, 300);

 $(document).on('click', '.featured-product-landing .product__info-wrapper .product-form__controls-group.subscription--active .product-meta-selector .product-form__input input[type=radio]', function() {
   let sellingId = $(this).attr('selling___id');
   let addForm = $(this).parents('.featured-product-landing').find('.product-form form');
   let sellingPlanInput = addForm.find('input[name="selling_plan"]');
   if (sellingPlanInput.length > 0) {
      sellingPlanInput.val(sellingId);
   } else {
      addForm.append('<input type="hidden" name="selling_plan" value="' + sellingId + '">');
   }
 });  
 $(document).on('click', '.featured-product-landing .product__info-wrapper .cdk--custom_subscription_options .subscription_pan_item[data-type="onetime-radio"]', function() {
   $(this).parents('.featured-product-landing').find('.product-form form input[name="selling_plan"]').val('');
 }); 
 
 $(document).on('click', '.featured-product-landing .product__info-wrapper .cdk--custom_subscription_options .subscription_pan_item[data-type="subscription-radio"]', function() {
   let sellingId = $(this).parents('.featured-product-landing').find('.product__info-wrapper .product-form__controls-group .product-meta-selector .product-form__input input[type=radio]:checked').attr('selling___id');
   let addForm = $(this).parents('.featured-product-landing').find('.product-form form');
   let sellingPlanInput = addForm.find('input[name="selling_plan"]');
   if (sellingPlanInput.length > 0) {
      sellingPlanInput.val(sellingId);
   } else {
      addForm.append('<input type="hidden" name="selling_plan" value="' + sellingId + '">');
   }
 });

  
  $(document).on("click", ".video__wrapper_play", function () {
    $(this).hide();
    $(this).parents(".custom-image-text").find(".video__wrapper_video-overlay").hide();
    $(this).parents(".custom-image-text").find(".split-image video").trigger("play");
  });

  $(document).on("click", ".subscription_popup_open", function () {
    $('.subscription_popup').removeClass("hide_popup");
  });

  $(document).on("click", ".subscription_popup .popup__close, .subscription_popup .overlay_wrap", function () {
    $('.subscription_popup').addClass("hide_popup");
  });

  $(document).on("click", ".ingredients_popup_open", function () {
    $('.ingredients_popup').removeClass("hide_popup");
  });

  $(document).on("click", ".ingredients_popup .popup__close, .ingredients_popup .overlay_wrap", function () {
    $('.ingredients_popup').addClass("hide_popup");
  });

  $(document).on("click", ".faq_content .question", function () {
    const $this = $(this);
    const isActive = $this.parents('.faq_content').hasClass("active");
    $(".faq_content").removeClass("active");
    $(".answer").slideUp(150);
    if (!isActive) {
      $this.parents('.faq_content').addClass("active");
      $this.parents('.faq_content').find(".answer").slideDown(150);
    }
  });


  
 
});

$('.review-slider').slick({
  dots: false,
  arrows: false,
  infinite: true,
  autoplay: false,
  autoplaySpeed: 3000,
  slidesToShow: 2,
  slidesToScroll: 1,
  prevArrow:"<svg class='prev-arrow' width='100%' height='100%' viewBox='0 0 32 32' fill='none' xmlns='http://www.w3.org/2000/svg'><circle cx='16' cy='16' r='16' fill='' fill-opacity='1'></circle><path d='M18.5 8.5L11 16L18.5 23.5' stroke='#1e988a' stroke-width='2' stroke-linecap='square'></path></svg>",
  nextArrow:"<svg class='next-arrow' width='100%' height='100%' viewBox='0 0 32 32' fill='none' xmlns='http://www.w3.org/2000/svg'><circle cx='16' cy='16' r='16' fill='' fill-opacity='1'></circle><path d='M13.5 8.5L21 16L13.5 23.5' stroke='#1e988a' stroke-width='2' stroke-linecap='square'></path></svg>",
    responsive: [
    {
      breakpoint: 768,
      settings: {
        slidesToShow: 1,
        arrows: true,
        slidesToScroll: 1
      }
    }
  ]
 });

 $('.multi-slider').slick({
  dots: true,
  arrows: false,
  infinite: true,
  autoplay: true,
  autoplaySpeed: 3000,
  slidesToShow: 3,
  slidesToScroll: 1,
  prevArrow:"<svg class='prev-arrow' width='100%' height='100%' viewBox='0 0 32 32' fill='none' xmlns='http://www.w3.org/2000/svg'><circle cx='16' cy='16' r='16' fill='' fill-opacity='1'></circle><path d='M18.5 8.5L11 16L18.5 23.5' stroke='#1e988a' stroke-width='2' stroke-linecap='square'></path></svg>",
  nextArrow:"<svg class='next-arrow' width='100%' height='100%' viewBox='0 0 32 32' fill='none' xmlns='http://www.w3.org/2000/svg'><circle cx='16' cy='16' r='16' fill='' fill-opacity='1'></circle><path d='M13.5 8.5L21 16L13.5 23.5' stroke='#1e988a' stroke-width='2' stroke-linecap='square'></path></svg>",
    responsive: [
    {
      breakpoint: 991,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1
      }
    },
    {
      breakpoint: 750,
      settings: {
        slidesToShow: 1
      }
    },  
  ]
 });

$('.announcement_wrapper.announcement_slider').slick({
  dots: false,
  arrows: true,
  infinite: true,
  autoplay: true,
  autoplaySpeed: 3000,
  slidesToShow: 1,
  slidesToScroll: 1,
  prevArrow:"<svg class='prev-arrow' width='100%' height='100%' viewBox='0 0 32 32' fill='none' xmlns='http://www.w3.org/2000/svg'><circle cx='16' cy='16' r='16' fill='' fill-opacity='1'></circle><path d='M18.5 8.5L11 16L18.5 23.5' stroke='#1e988a' stroke-width='2' stroke-linecap='square'></path></svg>",
  nextArrow:"<svg class='next-arrow' width='100%' height='100%' viewBox='0 0 32 32' fill='none' xmlns='http://www.w3.org/2000/svg'><circle cx='16' cy='16' r='16' fill='' fill-opacity='1'></circle><path d='M13.5 8.5L21 16L13.5 23.5' stroke='#1e988a' stroke-width='2' stroke-linecap='square'></path></svg>",
    responsive: [
    {
      breakpoint: 991,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1
      }
    }
  ]
 });

document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('.read-more-inline').forEach(function (link) {
    link.addEventListener('click', function () {
      const container = this.closest('.expandable-paragraph');
      const preview = container.querySelector('.preview-text');
      const full = container.querySelector('.full-text');

      if (full.style.display === 'none') {
        preview.style.display = 'none';
        full.style.display = 'block';
        this.textContent = 'Read Less';
      } else {
        preview.style.display = 'block';
        full.style.display = 'none';
        this.textContent = 'Read More';
      }
    });
  });
});

 $('.multi_card-slider').slick({
  dots: false,
  arrows: false,
  infinite: true,
  autoplay: true,
  autoplaySpeed: 3000,
  slidesToShow: 2,
  slidesToScroll: 1,
      responsive: [
    {
      breakpoint: 991,
      settings: {
        slidesToShow: 1,
        dots: true,
        slidesToScroll: 1
      }
    }  
  ]
 });

 const joinWaitlistBtn = document.querySelector('.join-wailist');

 if (joinWaitlistBtn) {
     joinWaitlistBtn.addEventListener('click', function () {
      window._klOnsite = window._klOnsite || [];
      window._klOnsite.push(['openForm', 'YbWXeK']);
     });
 }
